import { useState, useEffect, useCallback } from "react";
import axios from "axios";

export interface OrderSession {
  orderIdx: string;
  showIdx: string;
  ttl?: number;
}

export const useOrderSession = () => {
  const [order, setOrderState] = useState<OrderSession | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  const fetchOrder = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get("/api/booking/session");
      if (res.data && res.data.order) {
        setOrderState(res.data.order);
      } else {
        setOrderState(null);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const setOrder = useCallback(async (data: OrderSession) => {
    try {
      await axios.post("/api/booking/session", data);
      setOrderState(data);
    } catch (err) {
      console.error("Failed to set order session", err);
      throw err;
    }
  }, []);

  const clearOrder = useCallback(async () => {
    try {
      await axios.delete("/api/booking/session");
      setOrderState(null);
    } catch (err) {
      console.error("Failed to clear order session", err);
    }
  }, []);

  useEffect(() => {
    fetchOrder();
  }, [fetchOrder]);

  return {
    order,
    loading,
    error,
    refreshOrder: fetchOrder,
    setOrder,
    clearOrder,
  };
};
